import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./ConfirmationPop.module.scss";

// img

export const allModels = {
  logout: {
    title: "Do you want to Logout?",
    cancelText: "No",
    confirmText: "Yes",
  },
  delete: {
    title: "Are you sure you want to delete?",
    cancelText: "No",
    confirmText: "Delete",
  },
  archive: {
    title: "Are you sure you want to change status to archive?",
    cancelText: "No",
    confirmText: "Yes",
  },
  active: {
    title: "Are you sure you want to change status to active?",
    cancelText: "No",
    confirmText: "Yes",
  },
  inactive: {
    title: "Are you sure you want to change status to inactive?",
    cancelText: "No",
    confirmText: "Yes",
  },
  incoming: {
    title: "Are you sure you want to change status to incoming?",
    cancelText: "No",
    confirmText: "Yes",
  },
  discharged: {
    title: "Are you sure you want to change status to discharge?",
    cancelText: "No",
    confirmText: "Yes",
  },
  update: {
    title: "Are you sure you want to update?",
    cancelText: "No",
    confirmText: "Update",
  },
  remove: {
    title: "Are you sure you want to remove?",
    cancelText: "No",
    confirmText: "Remove",
  },
  pin: {
    title: "Are you sure you want to pin?",
    cancelText: "No",
    confirmText: "Yes",
  },
  unpin: {
    title: "Are you sure you want to unpin?",
    cancelText: "No",
    confirmText: "Yes",
  },
  resendAccountActivationMail: {
    title: "Are you sure you want resend account activation mail?",
    cancelText: "No",
    confirmText: "Send",
  },
  regenerate: {
    title: "Are you sure you want to export again?",
    cancelText: "No",
    confirmText: "Yes",
  },
  verifyAccount: {
    title: "Are you sure you want to verify this account?",
    cancelText: "No",
    confirmText: "Yes",
  },
  verifyConsentForm: {
    title: "Are you sure you want to verify this consent form?",
    cancelText: "No",
    confirmText: "Yes",
  },
  sendAppointmentMail: {
    title: "Are you sure you want to send mail?",
    cancelText: "No",
    confirmText: "Yes",
  },
  restore: {
    title: "Are you sure you want to restore?",
    cancelText: "No",
    confirmText: "Yes",
  },
  unassign: {
    title: "Are you sure you want to unassign?",
    cancelText: "No",
    confirmText: "Yes",
  },
  unassignAll: {
    title: "Are you sure you want to unassign all?",
    cancelText: "No",
    confirmText: "Yes",
  },
  assignChatter: {
    title: "Are you sure you want to assign chatter?",
    cancelText: "No",
    confirmText: "Yes",
  },
  unassignChatter: {
    title: "Are you sure you want to unassign chatter?",
    cancelText: "No",
    confirmText: "Yes",
  },
  checkList: {
    title: "Are you sure you want to delete checklist?",
    cancelText: "No",
    confirmText: "Yes",
  },
  caseloadDischarge: {
    title: "Are you sure you want to discharge?",
    cancelText: "No",
    confirmText: "Yes",
  },
  newCaseload: {
    title: "Are you sure you want to create new caseload?",
    cancelText: "No",
    confirmText: "Yes",
  },
  deleteTherapistAssignedClientType: {
    title: "Are you sure you want to remove this assigned client category? Doing so will prevent the therapist from accessing any clients of this type.",
    cancelText: "No",
    confirmText: "Yes",
  }
};

const ConfirmationPop = ({
  confirmation,
  setConfirmation,
  confirmHandler,
  type,
}) => {
  const hideHandler = () => {
    setConfirmation(false);
  };
  return (
    <>
      <Modal
        show={confirmation}
        className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal`}
        onHide={hideHandler}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="px-md-5 text-center mx-auto">
            <h3 className={`${styles.modalMessage} m-0 fw-bold themeBlue`}>{allModels[type]?.title}</h3>
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10 d-flex justify-content-center">
              <div className="px-2">
                <Button
                  onClick={hideHandler}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn GreyBtn`}
                >
                  {allModels[type]?.cancelText}
                </Button>
              </div>
              <div className="px-2">
                <Button
                  onClick={confirmHandler}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn`}
                >
                  {allModels[type]?.confirmText}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


export const ConfirmationPopCustom = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmBtnText,
  cancelBtnText,
  type,
}) => {
  // Get modal data based on type or use an empty object
  const modalData = allModels[type] || {};

  return (
    <>
      <Modal
        show
        className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal`}
        onHide={onCancel}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Body className={`${styles.modalBody}`}>
          <div className="px-md-5 text-center mx-auto">
            <h3 className={`${styles.modalMessage} m-0 fw-bold themeBlue`}>
              {title || modalData.title || "Are you sure?"}
            </h3>
            {/* <p className="my-2">{message || modalData.message || ""}</p> */}
            <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10 d-flex justify-content-center">
              <div className="px-2">
                <Button
                  onClick={onCancel}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn GreyBtn`}
                >
                  {cancelBtnText || modalData.cancelText || "Cancel"}
                </Button>
              </div>
              <div className="px-2">
                <Button
                  onClick={onConfirm}
                  className={`${styles.modalButton} fw-sbold d-flex align-items-center justify-content-center commonBtn`}
                >
                  {confirmBtnText || modalData.confirmText || "Confirm"}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default ConfirmationPop;